import { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route, withRouter } from 'react-router-dom'

import './styles/main.scss'
import './iconfonts/iconfont.css'

import Home from './pages/Home'
import About from './pages/About'
import Product from './pages/Product'
import ProductDetail from './pages/ProductDetail'
import News from './pages/News'
import NewsDetail from './pages/NewsDetail'
import Tip from './pages/Tip'
import NotFound from './pages/NotFound'

import { setLanguage } from './reducer'

import { isLowVersionBrowser } from './utils/func'

class App extends Component {

  componentDidMount () {
    let lang = ''
    if (navigator.language.toLocaleLowerCase() === 'zh-cn') {
      lang = 'cn'
    } else {
      lang = 'en'
    }
    this.props.setLanguage(lang)

    if (isLowVersionBrowser()) {
      this.props.history.replace('/tip')
      return
    }
  }

  render () {
    return (
      <Switch>
        <Route exact path='/' component={Home}></Route>
        <Route exact path='/about' component={About}></Route>
        <Route exact path='/product' component={Product}></Route>
        <Route exact path='/product/detail' component={ProductDetail}></Route>
        <Route exact path='/news' component={News}></Route>
        <Route exact path='/news/detail' component={NewsDetail}></Route>
        <Route exact path='/tip' component={Tip}></Route>
        <Route component={NotFound}></Route>
      </Switch>
    )
  }
}

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    setLanguage: data => {
      dispatch(setLanguage(data))
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
